import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { message } from 'services/snackbar'
import { StoreThunkDispatch } from 'store/state'

interface SubmitShortcutArgs {
  enabled: boolean
  isReady: boolean
  notReadyMessage?: string
  onSubmit: () => void
}

const DEFAULT_NOT_READY_MESSAGE = 'Your post is not ready! Fix the errors and try again.'

// Submits the composer with Ctrl+Shift+Enter (Cmd+Shift+Enter on macOS).
export function useSubmitShortcut(args: SubmitShortcutArgs) {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const { enabled, isReady, notReadyMessage = DEFAULT_NOT_READY_MESSAGE, onSubmit } = args

  useEffect(() => {
    if (!enabled) {
      return undefined
    }

    const onKeyUp = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'Enter') {
        if (!isReady) {
          dispatch(message(notReadyMessage, 'warning'))
          return
        }
        onSubmit()
      }
    }

    window.addEventListener('keyup', onKeyUp)
    return () => {
      window.removeEventListener('keyup', onKeyUp)
    }
  }, [dispatch, enabled, isReady, notReadyMessage, onSubmit])
}
